import configService from "../../services/configService";
import type { InvestorAlphaRouteState } from "../../types/investorAlpha";

export function isAlphaDevPreviewEnvironment(environment?: string): boolean {
  const normalizedEnvironment = environment?.trim().toLowerCase();
  return normalizedEnvironment === "local" || normalizedEnvironment === "dev";
}

export function isAlphaDevPreviewFlow(
  state: unknown,
  requestedPreview = false
): boolean {
  if (!isAlphaDevPreviewEnvironment(configService.getEnvironment())) return false;

  const routeState: InvestorAlphaRouteState = state
    && typeof state === "object"
    && !Array.isArray(state)
    ? state as InvestorAlphaRouteState
    : {};

  return requestedPreview || routeState.alphaDevPreview === true;
}

export function alphaDevPreviewState(isDevPreview: boolean): { alphaDevPreview: true } | {} {
  return isDevPreview ? { alphaDevPreview: true } : {};
}
